export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["UNSEEN"] = "UNSEEN";
    NotificationStatus["SEEN_BUT_UNREAD"] = "SEEN_BUT_UNREAD";
    NotificationStatus["READ"] = "READ";
    NotificationStatus["RESOLVED"] = "RESOLVED";
    NotificationStatus["DISMISSED"] = "DISMISSED";
    NotificationStatus["DELETED"] = "DELETED";
})(NotificationStatus || (NotificationStatus = {}));
export var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus["Unsubscribed"] = "Unsubscribed";
    RegistrationStatus["Subscribed"] = "Subscribed";
})(RegistrationStatus || (RegistrationStatus = {}));
export var PushChannel;
(function (PushChannel) {
    PushChannel["Mobile"] = "Mobile";
    PushChannel["Browser"] = "Browser";
})(PushChannel || (PushChannel = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map